<label style="color: white;">_</label>
<p-floatLabel>
  <p-multiSelect
    [options]="artistService.artistDataList"
    [(ngModel)]="objChant.artistListSelected"
    optionLabel="name"
    [formControl]="control"
    [filter]="true"
    display="chip"
    [showClear]="true"
    placeholder="- Select -" Width="100%" styleClass="width: 100%;">
    <ng-template let-row pTemplate="item">
        <div class="flex align-items-center gap-2">
          <img width="25" [src]="row.bannerOrNoImagePathUrl" class="img-circle" />
          {{ row.name }}
        </div>
    </ng-template>
    <ng-template let-value pTemplate="selectedItems">
      <p-chip *ngFor="let option of value" [label]="option.name" [image]="option.bannerOrNoImagePathUrl" [removable]="true" styleClass="font-size:9px" />
      <div *ngIf="!value || value.length === 0">Select Artist</div>
  </ng-template>
    <ng-template let-row pTemplate="footer">
      <div class="tc">
        <button *ngIf="showAddButton" type="button" (click)="onAddArtistButtonClick" class="btn btn-info" >
          <i class="fa fa-plus"></i> {{artistService.enumText.New}} artist
        </button>
      </div>
      <div class="py-2 px-3">
          <b>
          {{ objChant.artistListSelected ? objChant.artistListSelected.length : 0 }}
          </b>
          item{{ (objChant.artistListSelected ? objChant.artistListSelected.length : 0) > 1 ? 's' : '' }} selected.
      </div>
    </ng-template>
  </p-multiSelect>
  <label for="float-label">Artist
    <span *ngIf="artistService.artistDataList.length>0">(<b>{{artistService.artistDataList.length}}</b> items)</span> -
    <b>
    {{ objChant.artistListSelected ? objChant.artistListSelected.length : 0 }}
    </b>
    item{{ (objChant.artistListSelected ? objChant.artistListSelected.length : 0) > 1 ? 's' : '' }} selected.</label>
</p-floatLabel>

<div class="clearfix card1" *ngIf="objChant.artistListSelected">
  @for (genre of objChant.artistListSelected; track genre) {
    <span class="chip form-chantUser"><p-chip [label]="genre.name" [removable]="false" styleClass="font-size:9px" /></span>
  }
</div>
